/**
 * Product identity, in one place.
 *
 * Every screen reads the name from here. Renaming the product is then a
 * change here and to the drawings in assets/brand/ (components/ui/Logo.tsx,
 * the tab icon in index.html) rather than a search across components.
 */

export interface Brand {
  /** The logo's text alternative and the document title. */
  readonly name: string;
  /** One short line under the logo. Not a slogan; a description. */
  readonly tagline: string;
}

export const BRAND: Brand = {
  name: 'Orbiter',
  tagline: 'Управление сетью сайтов',
};

/** Page title for a given screen. Kept here so the pattern stays consistent. */
export function documentTitle(screen?: string): string {
  return screen ? `${screen} · ${BRAND.name}` : BRAND.name;
}
